import getAuthData from './getAuthData';

export default async (password, cb) => {
    const authData = getAuthData();
    const url = `${process.env.REACT_APP_API_URL}/auth/${authData.userData.id}`;

    const request = await fetch(url, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${authData.token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            password
        })
    });

    if (request.status === 200) {
        if (typeof cb === "function")
            cb();

        return true;
    }

    return false;
}

export const authorizeUser =  async (username, password, userDataCallback, cb) => {
    const authData = getAuthData();
    const url = `${process.env.REACT_APP_API_URL}/auth/user/${username}`;

    const request = await fetch(url, {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${authData.token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            password
        })
    });

    const response = await request.json();

    if (request.status === 200) {
        if (typeof cb === "function"){
            userDataCallback(response.token);
            setTimeout(cb, 250);
        }
    }

    return response;
}